<template>
  <div>
    <Head :title="`Customer #${form.customer.id}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/customers">Customers</Link>
        <span class="text-indigo-400 font-medium">/</span>
        Customer #{{ form.customer.id }}
      </h1>
    </div>

      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mb-10 text-[14px]">
          <div class="w-full text-center">
              <h3 class="font-medium text-gray-900 text-center p-5 text-[18px]">Base info</h3>

              <div class="flex flex-row font-bold border-t border-b border-gray-200 bg-gray-100">
                  <div class="w-[7%] px-2 py-3 border-r border-gray-200">#ID</div>
                  <div class="w-[10%] px-2 py-3 border-r border-gray-200">Mgmt ID</div>
                  <div class="w-[8%] px-2 py-3 border-r border-gray-200">Brand</div>
                  <div class="w-[30%] px-2 py-3 border-r border-gray-200">Email</div>
                  <div class="w-[15%] px-2 py-3 border-r border-gray-200">Phone</div>
                  <div class="w-[8%] px-2 py-3 border-r border-gray-200">Source</div>
                  <div class="w-[11%] px-2 py-3 border-r border-gray-200">Created at</div>
                  <div class="w-[11%] px-2 py-3 border-r border-gray-200">Login at</div>
              </div>

              <div class="flex flex-row border-b border-gray-200">
                  <div class="w-[7%] px-2 py-3 border-r border-gray-200">{{ form.customer.id}}</div>
                  <div class="w-[10%] px-2 py-3 border-r border-gray-200">{{ form.customer.mgmt_id}}</div>
                  <div class="w-[8%] px-2 py-3 border-r border-gray-200">{{ form.customer.brand_name}}</div>
                  <div class="w-[30%] px-2 py-3 border-r border-gray-200">{{ form.customer.email}}</div>
                  <div class="w-[15%] px-2 py-3 border-r border-gray-200">{{ form.customer.phone}}</div>
                  <div class="w-[8%] px-2 py-3 border-r border-gray-200">{{ form.customer.utm_source}}</div>
                  <div class="w-[11%] px-2 py-3 border-r border-gray-200">{{ moment(form.customer.created_at).format('YYYY-MM-DD HH:mm') }}</div>
                  <div class="w-[11%] px-2 py-3 border-r border-gray-200">{{ form.customer.login_at ? moment(form.customer.login_at).format('YYYY-MM-DD HH:mm') : '' }}</div>
              </div>

              <h3 class="font-medium text-gray-900 text-center p-5 text-[18px]">Auto Action expired at</h3>
              <div class="flex flex-row border-b border-gray-200">
                  <div class="w-[100%] px-2 py-3 border-r border-gray-200">{{autoAction}}</div>
              </div>

              <h3 class="font-medium text-gray-900 text-center p-5 text-[18px]">Personal data</h3>

<!--              <div class="flex flex-row flex-wrap">-->
              <div class="grid" style="grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); align-items: stretch;">
                  <div v-for="(value, key) in form.customer.data" :key="key" class="flex flex-col">
                      <div class="bg-gray-100 font-bold p-2 border-b border-r border-gray-200">{{ key }}</div>
                      <div class="p-2 border-r border-b border-gray-200" style="flex-grow: 1; word-wrap: break-word;">
                          <span class="value" v-if="value">{{ value }}</span>
                          <span class="value" v-else>&nbsp;</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">Orders</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Offer ID</th>
                          <th class="pb-4 pt-6 px-6">External order ID</th>
                          <th class="pb-4 pt-6 px-6">Status</th>
                          <th class="pb-4 pt-6 px-6">Stage</th>
                          <th class="pb-4 pt-6 px-6" colspan="2">CreatedAt</th>
                      </tr>
                      <tr v-for="order in orders" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/orders/${order.id}`">
                                  {{ order.id }}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/orders/${order.id}`">
                                  {{ order.offer_id }}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/orders/${order.id}`">
                                  {{ order.external_order_id }}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/orders/${order.id}`">
                                  {{ order.status }}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/orders/${order.id}`">
                                  {{ order.stage }}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/orders/${order.id}`">
                                  {{ order.created_at }}
                              </Link>
                          </td>
                      </tr>
                      <tr v-if="orders.length === 0">
                          <td class="px-6 py-4 border-t" colspan="4">No orders found.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>
      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">Chats</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Girl ID</th>
                          <th class="pb-4 pt-6 px-6">Unread messages</th>
                          <th class="pb-4 pt-6 px-6">Girl last activity</th>
                          <th class="pb-4 pt-6 px-6" colspan="2">Last message</th>
                      </tr>
                      <tr v-for="chat in chats" :key="chat.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{ chat.id }}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{chat.girl.firstname}} {{chat.girl.lastname}} ({{ chat.girl.id }})
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{chat.unread_messages_count}}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{chat.girl.last_activity}}
                              </Link>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/chats/${chat.id}`">
                                  {{ chat.last_message ? chat.last_message.text : 'no last message' }}
                              </Link>
                          </td>
                      </tr>
                      <tr v-if="chats.length === 0">
                          <td class="px-6 py-4 border-t" colspan="5">No chats found.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>
      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">List of girls who have been liked by the customer</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Girl ID</th>
                          <th class="pb-4 pt-6 px-6">Like time</th>
                      </tr>
                      <tr v-for="like in likesFromCustomer" :key="like.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ like.id }}
                              </div>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/girls/${like.girl.id}`">
                                  {{like.girl.firstname}} {{like.girl.lastname}} ({{ like.girl.id }})
                              </Link>
                          </td>
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ this.formatDate(like.created_at) }}
                              </div>
                          </td>
                      </tr>
                      <tr v-if="likesFromCustomer.length === 0">
                          <td class="px-6 py-4 border-t" colspan="5">No Likes found.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>

      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">List of girls who liked the customer</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Girl ID</th>
                          <th class="pb-4 pt-6 px-6">Like time</th>
                      </tr>
                      <tr v-for="like in likesToCustomer" :key="like.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ like.id }}
                              </div>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/girls/${like.girl.id}`">
                                  {{like.girl.firstname}} {{like.girl.lastname}} ({{ like.girl.id }})
                              </Link>
                          </td>
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ this.formatDate(like.created_at) }}
                              </div>
                          </td>
                      </tr>
                      <tr v-if="likesToCustomer.length === 0">
                          <td class="px-6 py-4 border-t" colspan="5">No Likes found.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>

      <div class="max-w-full bg-white rounded-md shadow overflow-hidden mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">List of girls who was visited by customer</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                  <table class="w-full whitespace-nowrap">
                      <tr class="text-left font-bold">
                          <th class="pb-4 pt-6 px-6">ID</th>
                          <th class="pb-4 pt-6 px-6">Girl ID</th>
                          <th class="pb-4 pt-6 px-6">Visit time</th>
                      </tr>
                      <tr v-for="visit in visitsFromCustomer" :key="visit.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ visit.id }}
                              </div>
                          </td>
                          <td class="border-t">
                              <Link preserve-scroll class="flex items-center px-6 py-4 focus:text-indigo-500"
                                    :href="`/girls/${visit.girl.id}`">
                                  {{visit.girl.firstname}} {{visit.girl.lastname}} ({{ visit.girl.id }})
                              </Link>
                          </td>
                          <td class="border-t">
                              <div class="flex items-center px-6 py-4 focus:text-indigo-500">
                                  {{ this.formatDate(visit.created_at) }}
                              </div>
                          </td>
                      </tr>
                      <tr v-if="visitsFromCustomer.length === 0">
                          <td class="px-6 py-4 border-t" colspan="5">No Visits yeat.</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import moment from "moment";

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
      customer: Object,
      orders: Array,
      chats: Array,
      likesFromCustomer: Array,
      likesToCustomer: Array,
      visitsFromCustomer: Array,
      autoAction: String
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        customer: this.customer
      }),
        moment: moment
    }
  },
  methods: {
      formatDate(value) {
          const date = moment.unix(value).utc();
          return date.format("YYYY-MM-DD HH:mm:ss")
      },
  },
}
</script>
